"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clock = void 0;
var Clock_js_1 = __importDefault(require("./Clock.js"));
exports.Clock = Clock_js_1.default;
exports.default = Clock_js_1.default;
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clock = void 0;
var Clock_js_1 = __importDefault(require("./Clock.js"));
exports.Clock = Clock_js_1.default;
exports.default = Clock_js_1.default;
